import {
  CASHFLOW_ITEM_KIND_LABELS,
  CASHFLOW_SCENARIO_LABELS,
  type CashflowItemKindValue,
  type CashflowProjectedItem,
} from "@station/contracts";
import { StatusBadge } from "@station/ui";
import { Link } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useMe } from "../../lib/session.js";
import { cashflowSourceTarget } from "./scenario-values.js";

export { CASHFLOW_SCENARIO_LABELS };

/** Kalem türü etiketi; sözleşmede olmayan tür (yeni kaynak) ham koduyla gösterilir. */
export function itemKindLabel(kind: string): string {
  return (CASHFLOW_ITEM_KIND_LABELS as Record<string, string>)[kind as CashflowItemKindValue] ?? kind;
}

/**
 * Kullanıcının istasyon kapsamı. `stationScope` null ise şirket geneli görülebilir; dizi ise kullanıcı
 * yalnızca o istasyonları görebilir ve nakit akışta ŞİRKET GENELİ seçeneği yoktur (uç 403 döner).
 */
export function useStationScope(): { restricted: boolean; allowedStationIds: string[] } {
  const scope = useMe().data?.activeTenant?.stationScope ?? null;
  return { restricted: scope !== null && scope.length > 0, allowedStationIds: scope ?? [] };
}

/** Açık günü rozeti: renk + METİN (anlam yalnızca renkle taşınmaz). */
export function ShortfallBadge({ shortfall }: { shortfall: boolean }): ReactElement {
  const { t } = useTranslation();
  return shortfall ? (
    <StatusBadge tone="danger">{t("cashFlow.shortfall")}</StatusBadge>
  ) : (
    <StatusBadge tone="success">{t("cashFlow.noShortfall")}</StatusBadge>
  );
}

/**
 * Kalemin kaynağına köprü. Ekranı olmayan kaynak türünde düz metin çizilir. `to` ve `params` yönlendiricinin
 * tiplerine uymadığı için `as never` ile geçilir — hedefler `scenario-values.ts` içinde testlidir.
 */
export function CashflowSourceLink({ item }: { item: CashflowProjectedItem }): ReactElement {
  const target = cashflowSourceTarget(item.sourceType, item.sourceId, item.counterpartyId);
  if (!target) return <span>{item.label}</span>;
  return (
    <Link
      to={target.to as never}
      {...(target.params ? { params: target.params as never } : {})}
      {...(target.search ? { search: target.search as never } : {})}
      className="underline underline-offset-4"
    >
      {item.label}
    </Link>
  );
}
